import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import {
  Button,
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@repo/videa-components/src/index';

interface EnableAdditionalBenefitsInfoHoverCardProps {
  isOpen: boolean;
  onSetUpCredentials?: () => void;
}

export const EnableAdditionalBenefitsInfoHoverCard = ({
  isOpen,
  onSetUpCredentials,
}: EnableAdditionalBenefitsInfoHoverCardProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <FontAwesomeIcon
          icon={faInfoCircle}
          className="vai-text-sapphire-600 vai-w-4 vai-h-4 hover:vai-text-sapphire-700 hover:vai-bg-gray-200 vai-p-2 vai-rounded vai-transition-all vai-duration-200"
        />
      </HoverCardTrigger>
      <HoverCardContent variant="primary" side="right" className="vai-w-72">
        <h3 className="vai-text-white vai-mb-2 vai-text-base vai-font-medium">
          <Trans>Enable More Benefits Information</Trans>
        </h3>
        <p className="vai-text-white vai-text-sm vai-mb-4">
          <Trans>
            Benefits information will be limited until you connect Videa to this
            payer portal.
          </Trans>
        </p>
        <div className="vai-flex vai-gap-2 vai-justify-end">
          <Button
            size="sm"
            className="vai-bg-white/30 hover:vai-bg-white/40"
            onClick={onSetUpCredentials}
          >
            <Trans>Set Up Credentials</Trans>
          </Button>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};
